import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Box, Drawer, IconButton, Typography } from '@mui/material';

interface Props {
  drawerHeader: string;
  open: boolean;
  onClose: VoidFunction;
  children: React.ReactNode;
}

const DrawerComponent: React.FC<Props> = ({
  open,
  drawerHeader,
  onClose,
  children,
}) => {
  return (
    <Drawer open={open} onClose={onClose} anchor="right">
      <Box display="flex" alignItems="center">
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
        <Typography>{drawerHeader}</Typography>
      </Box>
      {children}
    </Drawer>
  );
};

export default DrawerComponent;
